import './Badge.css';

/* ─────────────────────────────────────────────────────────────
   BADGE — Small pill label.

   Props:
   - children: the label text
   - variant:  'accent' | 'neutral'  (default: 'accent')

   Examples:
   <Badge>Now in early access</Badge>
   <Badge variant="neutral">Most popular</Badge>
   ───────────────────────────────────────────────────────────── */
function Badge({ children, variant = 'accent' }) {
  return (
    <span className={`badge badge-${variant}`}>{children}</span>
  );
}

export default Badge;
